var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center","no-gutters":""}},[_c('v-col',{staticClass:"pl-5 pt-3"},[_vm._t("default")],2),_c('v-col',{staticClass:"text-center pt-5"}),_c('v-col',{staticClass:"primary py-4 pr-5 text-end white--text",attrs:{"dark":""}},[_c('v-software-copyright')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }